import React, {ReactNode} from 'react';
import {useSiteMetadata} from '../Hooks/use-site-metadata';
import {defaultSchema} from '../Schemas/defaultSchema';

interface SEOProps {
  title: string;
  description: string;
  image?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogUrl?: string;
  ogType?: string;
  // ogSiteName?: string;
  pathname?: string;
  children?: ReactNode;
  schema?: object;
}

export const SEO = ({
  title,
  description,
  image,
  ogTitle,
  ogDescription,
  ogImage,
  ogUrl,
  ogType,
  // ogSiteName,
  pathname,
  schema,
  children,
}: SEOProps) => {
  const {
    lang,
    title: defaultTitle,
    description: defaultDescription,
    image: defaultImage,
    og: {type: defaultType, site_name: defaultSiteName},
    siteUrl,
  } = useSiteMetadata();

  const seo = {
    lang,
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: image || defaultImage,
    // image: `${siteUrl}${image}`,
    // image: `${image}`,
    og: {
      title: ogTitle || defaultTitle,
      description: ogDescription || defaultDescription,
      image: ogImage || defaultImage,
      url: ogUrl || siteUrl,
      type: ogType || defaultType,
      site_name: defaultSiteName,
    },
    url: `${siteUrl}${pathname || ``}`,
  };

  return (
    <>
      <html lang={seo.lang} />
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      {/* OPENGRAPH */}
      {/* Define o título do conteúdo que está sendo compartilhado. */}
      <meta property="og:title" content={seo.title} />
      {/* Define a descrição do conteúdo que está sendo compartilhado. */}
      <meta property="og:description" content={seo.description} />
      {/* Define a imagem associada ao conteúdo compartilhado. */}
      <meta property="og:image" content={seo.image} />
      {/* Define a URL da página que está sendo compartilhada. */}
      <meta property="og:url" content={seo.url} />
      {/* Define o tipo de conteúdo, como "website", "article", "video", etc. */}
      <meta property="og:type" content={seo.og.type} />
      {/* Define o nome do seu site. */}
      <meta property="og:site_name" content={seo.og.site_name} />
      {/* Define o idioma e a região do conteúdo. */}
      <meta property="og:locale" content="pt_BR" />
      <script type="application/ld+json">
        {JSON.stringify(schema || defaultSchema)}
      </script>
      {children}
    </>
  );
};
